import React from 'react'
import cuid from 'cuid'
import { useSnackbar } from 'notistack'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import { Trans } from 'react-i18next'
import { ReactComponent as UploadSvg } from 'core/assets/images/upload.svg'
import i18n from 'core/common/i18n'
import Typography from 'core/components/Typography'
import { actionsUpload, useUpload } from '../../context'
import { CardDropZone, DropZone, OutlineOff, StyledAddIcon, TextHighlight } from './style'

const Dropzone = ({ type, error }) => {
  const [stateUpload, dispatchUpload] = useUpload()
  const { enqueueSnackbar } = useSnackbar()

  const onDrop = acceptedFiles => {
    const currentFiles = stateUpload.FILES
    const newFiles = acceptedFiles.map(file => ({
      id: cuid(),
      src: URL.createObjectURL(file),
      file,
    }))

    const totalFilesAfterUpload = currentFiles.length + newFiles.length

    if (totalFilesAfterUpload > stateUpload.MAX_SELECT_FILES) {
      enqueueSnackbar(`O Upload excedeu o limite de ${stateUpload.MAX_SELECT_FILES} imagens`, {
        variant: 'error',
      })
      return
    }

    const filesToUpload = newFiles.map(file => ({
      ...file,
      uploadStatus: 'waiting',
      id_ref: file.id,
      selected: currentFiles.length === 0,
    }))

    if (filesToUpload.length)
      dispatchUpload({ type: actionsUpload.ADD_FILES, state: filesToUpload })
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: stateUpload.ACCEPT,
    maxFiles: stateUpload.MAX_SELECT_FILES,
    onDrop,
    onDropRejected: err => {
      const uploadErrors = err.reduce((acc, { errors }) => {
        if (errors.length) {
          const error = errors.find(e => e.code === 'too-many-files')
          if (error) {
            acc['too-many-files'] = 'too-many-files'
          }
        }
        return acc
      }, {})

      if ('too-many-files' in uploadErrors) {
        enqueueSnackbar(`O Upload excedeu o limite de ${stateUpload.MAX_SELECT_FILES} imagens`, {
          variant: 'error',
        })
      }
    },
  })

  const { ref, ...rootProps } = getRootProps()

  if (type === 'card') {
    return (
      <OutlineOff ref={ref} item {...rootProps}>
        <input {...getInputProps()} maxLength={stateUpload.MAX_SELECT_FILES} />
        <CardDropZone>
          <StyledAddIcon fontSize="large" />
        </CardDropZone>
      </OutlineOff>
    )
  }

  return (
    <DropZone ref={ref} error={error} {...rootProps}>
      <input {...getInputProps()} />
      <UploadSvg />
      <div>
        <Typography mt={2} align="center">
          {i18n.t('product.productUpload.dropzoneMessage')}
          <br />
          <Trans
            i18nKey="product.productUpload.dropzoneMessage2"
            components={{ l: <TextHighlight /> }}
          />
        </Typography>
      </div>
    </DropZone>
  )
}

Dropzone.defaultProps = {
  type: '',
  error: false,
}

Dropzone.propTypes = {
  type: PropTypes.string,
  error: PropTypes.bool,
}

export default Dropzone
